export default __webpack_public_path__ + "static/media/policy01_2023.f50435d6.jpg";